import React, {Component} from "react";

import {View}  from 'react-native';

import Combo from '../componentes/Combo'

import {buscarCategorias as wsBuscarCategorias} from '../ws/ws_categorias'

import {buscarSubcategorias as wsBuscarSubcategorias} from '../ws/ws_subcategorias'

import * as util from '../util/util'


export default class ComponenteCategoria extends Component {

	
	constructor(props) {
        
        super(props);
		
		this.state = {tipo: null};
		
		this.cbCategoriaRef = React.createRef();
		this.cbSubcategoriaRef = React.createRef();
    }
	
	
	setDados(tipo, id_categoria, id_subcategoria){

		this.buscarCategorias(tipo, id_categoria, id_subcategoria);	
    }
	
	
	async buscarCategorias(tipo, id_categoria, id_subcategoria){
		
		this.cbCategoriaRef.current.setCarregando(true)
		
		let lista = await wsBuscarCategorias(tipo);
		
		if(util.temConteudo(lista)){
			
			let selecionado = null;
			
			if(id_categoria!=null){
				for(var categoria of lista){
					if(categoria.id == id_categoria){
						selecionado = categoria;
						break;
					}
				}
			}
			
			if(selecionado==null)
				this.cbCategoriaRef.current.setDados(lista);
			else
				this.cbCategoriaRef.current.setDadosComSelecionado(lista, selecionado);	
		}
		
		
		if(id_categoria!=null)
			this.mudouCategoria(id_categoria, id_subcategoria)
		
		this.cbCategoriaRef.current.setCarregando(false)
	}
	
	
	async mudouCategoria(id_categoria_selecionada, id_subcategoria_selecionada=null){
		
		this.cbSubcategoriaRef.current.setCarregando(true)

		let tem = false;
        
		if(util.temConteudo(id_categoria_selecionada)){
		
			let lista = await wsBuscarSubcategorias(id_categoria_selecionada);
		
			if(util.temConteudo(lista)){
				
				let selecionado = null;
				
				tem = true;
				
				if(id_subcategoria_selecionada!=null){
					for(var subcategoria of lista){
						if(subcategoria.id == id_subcategoria_selecionada){
							selecionado = subcategoria;
							break;
						}
					}
				}
				
				if(selecionado==null)
					this.cbSubcategoriaRef.current.setDados(lista);
				else
					this.cbSubcategoriaRef.current.setDadosComSelecionado(lista, selecionado);	
			}	
		}		
		
		if(!tem)
			this.cbSubcategoriaRef.current.setDadosComSelecionado([], null)
		
		this.cbSubcategoriaRef.current.setCarregando(false) 
	}


	getDados(){

		return {
			id_categoria: this.cbCategoriaRef.current.getSelecionado()!=null?this.cbCategoriaRef.current.getSelecionado().id:null,
			id_subcategoria: this.cbSubcategoriaRef.current.getSelecionado()!=null?this.cbSubcategoriaRef.current.getSelecionado().id:null,
        };
    }
	
	
	salvarErro(mensagem){
		
        this.btSalvarRef.current.setCarregando(false);
		this.setState({msgErro: mensagem});
    }


	salvarSucesso(){
		
		this.btSalvarRef.current.setCarregando(false)
		this.setState({msgErro: null});
	}


    render() {
		return(
			<View>  
				<Combo 
					rotulo="Categoria:" 
					selecionado={null} 
					dados={[]} 
					aoMudar={(valor)=>this.mudouCategoria(valor!=null?valor.id:null)} 
					ref={this.cbCategoriaRef}/>
				
				<View style={{marginTop:30}}/> 
				
				<Combo 
					rotulo="Subcategoria  (opcional):" 
					selecionado={null} 
					dados={[]} 
					ref={this.cbSubcategoriaRef}/>
			</View> 
		)
   }
} 